import { ReactQueryClientService } from '#apps/client-web/app/services/react-query-client';
import { useLogger } from '#apps/client-web/app/hooks/use-logger';
import { auditFormService } from '#apps/client-web/features/audit-form/services/audit-form';
import { NestedPageLayout } from '#apps/client-web/app/components/nested-page-layout';

import { AuditFormLightingCountPageContainer } from './audit-form-lighting-count-page.container';
import { useAuditFormLightingCountPageViewModel } from './audit-form-lighting-count-page.view-model';

export const AuditFormLightingCountPage = () => {
  const logger = useLogger('pages/audit-form-lighting-count');

  const viewModel = useAuditFormLightingCountPageViewModel({
    auditFormService,
    queryClient: ReactQueryClientService.offlineQueryClient,
    logger,
  });

  return (
    <NestedPageLayout title="Lighting Count">
      <AuditFormLightingCountPageContainer viewModel={viewModel} logger={logger} />
    </NestedPageLayout>
  );
};
